import React from "react";
import Api from "../../services/api";

// Exportado para que paginas que usem o componente possam referenciar PlaceType.Chat etc.
// Os tipos 1..5 existentes nao mudaram para nao quebrar usos atuais.
//
// F5.10: Chat colapsa backend placetype 5 (Chat) + 6 (ChatCustomer) num unico grupo visual.
// `All` continua marcador frontend (filtro "todos exceto Chat") usado por automation/macro
// legacy. Esse valor NUNCA vem da API — eh so para filterByTypes.
export const PlaceType = {
  Chamado: 1,
  Portal: 2,
  Empresa: 3,
  Solicitante: 4,
  All: 5,
  Chat: 6, // variaveis de conversa (quick-responses no omnichannel + automation chat F5.10)
};

// F5.10 — Lista fallback usada quando a API /emailtemplates/placeholders/common falha.
// Shape identico ao que vem da API ja normalizado: {id, name, type}.
const placeholdersDataFallback = [
  // Chamado (Ticket)
  { id: "ticket.id", name: "Id do chamado", type: PlaceType.Chamado },
  { id: "ticket.title", name: "Título", type: PlaceType.Chamado },
  { id: "ticket.description", name: "Descrição", type: PlaceType.Chamado },
  { id: "ticket.due_date", name: "Data de previsão", type: PlaceType.Chamado },
  { id: "ticket.status.name", name: "Status", type: PlaceType.Chamado },
  { id: "ticket.priority.name", name: "Prioridade", type: PlaceType.Chamado },
  { id: "ticket.origin.name", name: "Origem", type: PlaceType.Chamado },
  { id: "ticket.type.name", name: "Tipo", type: PlaceType.Chamado },
  { id: "ticket.team.name", name: "Time", type: PlaceType.Chamado },
  { id: "ticket.category.name", name: "Categoria", type: PlaceType.Chamado },
  { id: "ticket.address.name", name: "Endereço", type: PlaceType.Chamado },
  {
    id: "ticket.organization.name",
    name: "Organização",
    type: PlaceType.Chamado,
  },
  { id: "ticket.hirer.name", name: "Empresa", type: PlaceType.Chamado },
  { id: "ticket.technical.name", name: "Técnico", type: PlaceType.Chamado },
  {
    id: "ticket.technical.email",
    name: "E-mail Técnico",
    type: PlaceType.Chamado,
  },
  { id: "ticket.observer.name", name: "Observador", type: PlaceType.Chamado },
  { id: "ticket.parent.name", name: "Chamado pai", type: PlaceType.Chamado },
  { id: "ticket.url", name: "Url do Ticket", type: PlaceType.Chamado },
  { id: "ticket.tags", name: "Tags", type: PlaceType.Chamado },
  {
    id: "ticket.acc.latest_public_comment",
    name: "Último acompanhamento público",
    type: PlaceType.Chamado,
  },
  {
    id: "ticket.acc.latest_private_comment",
    name: "Último acompanhamento privado",
    type: PlaceType.Chamado,
  },
  { id: "ticket.group.name", name: "Nome do Grupo", type: PlaceType.Chamado },

  // Portal
  { id: "portal.name", name: "Nome do portal", type: PlaceType.Portal },
  { id: "portal.title", name: "Título do portal", type: PlaceType.Portal },

  // Empresa
  { id: "hirer.name", name: "Nome contratante", type: PlaceType.Empresa },
  { id: "hirer.email", name: "E-mail contratante", type: PlaceType.Empresa },
  {
    id: "hirer.document",
    name: "Documento contratante",
    type: PlaceType.Empresa,
  },
  { id: "hirer.website", name: "Website contratante", type: PlaceType.Empresa },
  { id: "hirer.phone", name: "Fone contratante", type: PlaceType.Empresa },
  {
    id: "hirer.responsiblename",
    name: "Nome responsável",
    type: PlaceType.Empresa,
  },
  {
    id: "hirer.responsibleemail",
    name: "Email responsável",
    type: PlaceType.Empresa,
  },
  { id: "hirer.plan", name: "Plano contratado", type: PlaceType.Empresa },
  { id: "hirer.renewaldate", name: "Data renovação", type: PlaceType.Empresa },

  // Solicitante
  {
    id: "ticket.requester.name",
    name: "Nome solicitante",
    type: PlaceType.Solicitante,
  },
  {
    id: "ticket.requester.phone",
    name: "Fone solicitante",
    type: PlaceType.Solicitante,
  },
  {
    id: "ticket.requester.mail",
    name: "E-mail solicitante",
    type: PlaceType.Solicitante,
  },
  {
    id: "ticket.requester.document",
    name: "CPF solicitante",
    type: PlaceType.Solicitante,
  },
  {
    id: "ticket.requester.address",
    name: "Endereço solicitante",
    type: PlaceType.Solicitante,
  },

  // Chat (Conversa) — usadas em respostas rapidas no omnichannel
  { id: "chat.id", name: "Id do chat", type: PlaceType.Chat },
  { id: "chat.customer.name", name: "Nome do cliente", type: PlaceType.Chat },
  { id: "chat.customer.phone", name: "Fone do cliente", type: PlaceType.Chat },
  { id: "chat.customer.email", name: "E-mail do cliente", type: PlaceType.Chat },
  { id: "chat.channel.name", name: "Canal", type: PlaceType.Chat },
  { id: "chat.assigned.name", name: "Atendente do chat", type: PlaceType.Chat },
  { id: "chat.assigned.email", name: "E-mail do atendente", type: PlaceType.Chat },
  { id: "chat.team.name", name: "Time", type: PlaceType.Chat },
  { id: "chat.organization.name", name: "Organização", type: PlaceType.Chat },
  { id: "chat.created", name: "Data de abertura", type: PlaceType.Chat },
  { id: "chat.provider.name", name: "Provedor", type: PlaceType.Chat },
  { id: "chat.number.phone", name: "Número do telefone", type: PlaceType.Chat },
  { id: "chat.status.name", name: "Status", type: PlaceType.Chat },
  { id: "chat.priority.name", name: "Prioridade", type: PlaceType.Chat },
  { id: "chat.origin.name", name: "Origem", type: PlaceType.Chat },
  { id: "chat.category.name", name: "Categoria", type: PlaceType.Chat },
  { id: "chat.webchat.name", name: "Webchat", type: PlaceType.Chat },
  { id: "chat.chatbot.name", name: "Chatbot", type: PlaceType.Chat },
  { id: "user.name", name: "Nome do usuário logado", type: PlaceType.Chat },
  { id: "user.email", name: "E-mail do usuário logado", type: PlaceType.Chat },
];

const groups = [
  { id: PlaceType.Chamado, name: "Ticket", icon: "🎫" },
  { id: PlaceType.Portal, name: "Portal", icon: "🌐" },
  { id: PlaceType.Empresa, name: "Empresa", icon: "🏢" },
  { id: PlaceType.Solicitante, name: "Contato", icon: "👤" },
  { id: PlaceType.Chat, name: "Chat", icon: "💬" },
];

const styles = {
  addButton: {
    width: "40px",
    height: "40px",
    backgroundColor: "#4caf50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    transition: "background-color 0.2s",
  },
  addButtonHover: {
    backgroundColor: "#388e3c",
  },
  popupContainer: {
    position: "fixed",
    zIndex: 1000,
    filter: "drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15))",
  },
  popup: {
    backgroundColor: "white",
    width: "380px",
    maxHeight: "480px",
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    border: "1px solid #e0e0e0",
  },
  popupArrow: {
    position: "absolute",
    width: 0,
    height: 0,
    borderStyle: "solid",
  },
  popupHeader: {
    padding: "12px 16px",
    backgroundColor: "#f5f5f5",
    borderBottom: "1px solid #e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  popupTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
    color: "#666",
    padding: "2px",
    borderRadius: "4px",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s",
  },
  closeButtonHover: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  searchBox: {
    padding: "12px 16px",
    borderBottom: "1px solid #e0e0e0",
  },
  searchInputWrapper: {
    position: "relative",
  },
  searchInput: {
    width: "100%",
    padding: "8px 12px 8px 36px",
    fontSize: "14px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    outline: "none",
    transition: "border-color 0.2s",
  },
  searchInputFocused: {
    borderColor: "#1976d2",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#666",
    pointerEvents: "none",
  },
  placeholderList: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
  },
  groupHeader: {
    padding: "10px 16px",
    backgroundColor: "#f5f5f5",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e0e0e0",
    transition: "background-color 0.2s",
  },
  groupHeaderHover: {
    backgroundColor: "#e8e8e8",
  },
  groupTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  expandIcon: {
    fontSize: "16px",
    color: "#666",
    transition: "transform 0.2s",
  },
  placeholderItem: {
    padding: "10px 16px 10px 36px",
    cursor: "pointer",
    borderBottom: "1px solid #f0f0f0",
    transition: "background-color 0.2s",
  },
  placeholderItemHover: {
    backgroundColor: "rgba(25, 118, 210, 0.08)",
  },
  placeholderName: {
    fontSize: "13px",
    color: "#333",
    marginBottom: "2px",
  },
  placeholderCode: {
    fontSize: "12px",
    fontFamily: "monospace",
    backgroundColor: "rgba(25, 118, 210, 0.1)",
    color: "#1976d2",
    padding: "2px 6px",
    borderRadius: "3px",
    display: "inline-block",
  },
};

// quillRef: ref do ReactQuill (via ref={ref} no <ReactQuill/>). Quando informado, o clique
// numa variavel usa quill.insertText(index, texto) na posicao do cursor — o proprio Quill
// dispara onChange do editor com o novo conteudo, entao NAO chamamos onChange manualmente.
// textAreaRef + insertAtCursor: caminho legado pra <textarea> nativo (mantem selectionStart).
// Sem qualquer ref: concatena no fim do value (comportamento historico).
export default function AddCommonPlaceholder({
  value = "",
  onChange,
  textAreaRef = null,
  quillRef = null,
  types = [PlaceType.All],
  insertAtCursor = false,
  // Lista pronta do backend ({name, displayname, placetype}) — quando informada, NAO busca na API.
  // Usada pelas actions de e-mail da automacao (GET /automation/email-placeholders?target=).
  placeholders = null,
}) {
  const [popupOpen, setPopupOpen] = React.useState(false);

  const [searchTerm, setSearchTerm] = React.useState("");

  // F5.10 — placeholders carregados da API (/emailtemplates/placeholders/common) no mount.
  // Fallback: lista hardcoded (placeholdersDataFallback) se API falhar.
  const [placeholdersData, setPlaceholdersData] = React.useState(placeholdersDataFallback);
  const [placeholdersLoaded, setPlaceholdersLoaded] = React.useState(false);

  // Normaliza shape backend → frontend. Backend retorna {id, name, displayname, placetype}:
  //   name = "{{ticket.id}}" (com chaves)  → frontend: id = "ticket.id" (sem chaves)
  //   displayname = "Id do chamado"        → frontend: name
  //   placetype = 1..6                     → frontend: type (colapsa 5+6 em Chat=6)
  const normalizePlaceholders = (list) => {
    const mapPlaceType = (bk) => {
      if (bk === 5 || bk === 6) return PlaceType.Chat; // Chat + ChatCustomer colapsam
      return bk; // 1..4 bate 1:1
    };
    return (list || [])
      .map((p) => {
        const rawName = p.name || "";
        const idClean = rawName.replace(/^\{\{\s*/, "").replace(/\s*\}\}$/, "");
        return {
          id: idClean,
          name: p.displayname || idClean,
          type: mapPlaceType(p.placetype),
        };
      })
      .filter((p) => p.id);
  };

  // Lista pronta via prop: usa direto (ja filtrada pelo target no backend).
  React.useEffect(() => {
    if (!Array.isArray(placeholders)) return;
    setPlaceholdersData(normalizePlaceholders(placeholders));
    setPlaceholdersLoaded(true);
  }, [placeholders]);

  React.useEffect(() => {
    if (placeholdersLoaded || Array.isArray(placeholders)) return;
    // Rota sem claim (api/emailtemplates/placeholders/common). Antes: /email-templates/placeholders
    // (hifen, rota inexistente → 404 → sempre caia no fallback hardcoded).
    Api.get("/emailtemplates/placeholders/common")
      .then((r) => {
        if (r && r.data && r.data.success && Array.isArray(r.data.data)) {
          const normalized = normalizePlaceholders(r.data.data);
          if (normalized.length) setPlaceholdersData(normalized);
        }
      })
      .catch(() => { /* mantem fallback */ })
      .finally(() => setPlaceholdersLoaded(true));
  }, [placeholdersLoaded]);

  const [expandedGroups, setExpandedGroups] = React.useState({
    [PlaceType.Chamado]: true,
    [PlaceType.Portal]: true,
    [PlaceType.Empresa]: true,
    [PlaceType.Solicitante]: true,
    [PlaceType.Chat]: true,
  });
  const [popupPosition, setPopupPosition] = React.useState({ top: 0, left: 0 });
  const [cursorPosition, setCursorPosition] = React.useState(0);
  const [isAddButtonHovered, setIsAddButtonHovered] = React.useState(false);
  const [isCloseButtonHovered, setIsCloseButtonHovered] = React.useState(false);
  const [hoveredGroup, setHoveredGroup] = React.useState(null);
  const [hoveredItem, setHoveredItem] = React.useState(null);
  const [isSearchFocused, setIsSearchFocused] = React.useState(false);

  const popupRef = React.useRef(null);
  const buttonRef = React.useRef(null);

  const filteredPlaceholders = React.useMemo(() => {
    if (!searchTerm) return filterByTypes(placeholdersData, types);

    const lowerSearch = searchTerm.toLowerCase();
    return filterByTypes(placeholdersData, types).filter(
      (p) =>
        p.name.toLowerCase().includes(lowerSearch) ||
        p.id.toLowerCase().includes(lowerSearch)
    );
  }, [searchTerm, placeholdersData, types]);

  const groupedPlaceholders = React.useMemo(() => {
    const grouped = {};
    groups.forEach((group) => {
      grouped[group.id] = filteredPlaceholders.filter(
        (p) => p.type === group.id
      );
    });
    return grouped;
  }, [filteredPlaceholders, placeholdersData]);

  function filterByTypes(list, activeTypes) {
    if (activeTypes.includes(PlaceType.All)) {
      // Compatibilidade legacy: "All" sempre significou os tipos 1-4 (ticket, portal, empresa,
      // solicitante) — automation/macro chamam com [PlaceType.All] e nao devem passar a ver
      // variaveis de Chat. Para usar Chat, basta passar [PlaceType.Chat] explicitamente.
      return list.filter(item => item.type !== PlaceType.Chat);
    }
    return list.filter(item => activeTypes.includes(item.type));
  }

  const handleTogglePopup = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!popupOpen) {
      // Salva a posicao do cursor ANTES do popover roubar foco. Sem isso, quando o usuario
      // clica numa variavel o textarea/quill ja perdeu selectionStart/getSelection e nao
      // tem onde inserir. Suporta os 3 caminhos (Quill / textarea nativo / concat legado).
      if (quillRef && quillRef.current) {
        const quill = quillRef.current.getEditor && quillRef.current.getEditor();
        const sel = quill && quill.getSelection();
        setCursorPosition(sel ? sel.index : (quill ? quill.getLength() : 0));
      } else if (textAreaRef && textAreaRef.current) {
        setCursorPosition(textAreaRef.current.selectionStart || 0);
      }
    }

    setPopupOpen(!popupOpen);

    if (!popupOpen) {
      setSearchTerm("");
    }
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setSearchTerm("");
  };

  const handleToggleGroup = (groupId) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  const handleSelectPlaceholder = (placeholder) => {
    const placeholderText = `{{${placeholder.id}}}`;

    // Caminho 1 — ReactQuill: insertText dispara o onChange do editor sozinho, entao NAO
    // chamamos onChange manualmente (senao dobra o texto ou stomps HTML formatting).
    if (quillRef && quillRef.current) {
      const quill = quillRef.current.getEditor && quillRef.current.getEditor();
      if (quill) {
        const insertIndex = typeof cursorPosition === "number" ? cursorPosition : quill.getLength();
        quill.insertText(insertIndex, placeholderText, "user");
        handleClosePopup();
        setTimeout(() => {
          quill.setSelection(insertIndex + placeholderText.length, 0, "user");
          quill.focus();
        }, 50);
        return;
      }
    }

    const _value = value || "";

    let newValue;
    if (insertAtCursor && textAreaRef && textAreaRef.current) {
      newValue =
        _value.slice(0, cursorPosition) +
        placeholderText +
        _value.slice(cursorPosition);
    } else {
      newValue = _value + placeholderText;
    }

    const savedScrollTop = insertAtCursor && textAreaRef && textAreaRef.current
      ? textAreaRef.current.scrollTop
      : null;

    onChange(newValue);
    handleClosePopup();

    if (insertAtCursor && textAreaRef && textAreaRef.current) {
      setTimeout(() => {
        textAreaRef.current.focus();
        const newCursorPos = cursorPosition + placeholderText.length;
        textAreaRef.current.setSelectionRange(newCursorPos, newCursorPos);
        if (savedScrollTop !== null) {
          textAreaRef.current.scrollTop = savedScrollTop;
        }
      }, 100);
    }
  };

  const updatePosition = () => {
    if (popupOpen && buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const popupWidth = 380;
      const popupHeight = 480;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const margin = 20;
      const gap = 8;

      // ANTES: sem clamp no topo — se abrisse acima e o topo do popup ficasse negativo, o
      // header ficava fora da viewport (bug reportado no default-actions-edit).
      // AGORA: escolhe o lado com mais espaco; se nao couber inteiro em nenhum, adapta
      // maxHeight pra caber, mantendo o topo/base visiveis.
      const availableBelow = windowHeight - buttonRect.bottom - gap - margin;
      const availableAbove = buttonRect.top - gap - margin;

      let top;
      let showArrowTop;
      let maxHeight;

      if (availableBelow >= popupHeight) {
        top = buttonRect.bottom + gap;
        showArrowTop = true;
        maxHeight = popupHeight;
      } else if (availableAbove >= popupHeight) {
        top = buttonRect.top - popupHeight - gap;
        showArrowTop = false;
        maxHeight = popupHeight;
      } else if (availableBelow >= availableAbove) {
        // Fica abaixo com altura reduzida — topo sempre visivel (colado no botao).
        top = buttonRect.bottom + gap;
        showArrowTop = true;
        maxHeight = Math.max(200, availableBelow);
      } else {
        // Fica acima com altura reduzida — topo grudado no topo da viewport.
        top = margin;
        showArrowTop = false;
        maxHeight = Math.max(200, availableAbove);
      }

      // Calcular posição horizontal
      let left = buttonRect.left;

      // Ajustar se o popup sair da tela pela direita
      if (left + popupWidth > windowWidth - margin) {
        left = buttonRect.right - popupWidth;
      }

      // Garantir que não saia da tela pela esquerda
      if (left < margin) {
        left = margin;
      }

      setPopupPosition({
        top,
        left,
        showArrowTop,
        maxHeight,
        arrowLeft: buttonRect.left + buttonRect.width / 2 - left - 8,
      });
    }
  };

  React.useEffect(() => {
    if (popupOpen) {
      updatePosition();
      window.addEventListener("scroll", updatePosition);
      window.addEventListener("resize", updatePosition);
    }
    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, [popupOpen]);


  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupOpen &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setPopupOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [popupOpen]);

  return (
    <>
      <button
        ref={buttonRef}
        onClick={handleTogglePopup}
        style={{
          ...styles.addButton,
          ...(isAddButtonHovered ? styles.addButtonHover : {}),
        }}
        onMouseEnter={() => setIsAddButtonHovered(true)}
        onMouseLeave={() => setIsAddButtonHovered(false)}
        type="button"
      >
        +
      </button>

      {popupOpen && (
        <div
          ref={popupRef}
          style={{
            ...styles.popupContainer,
            position: "fixed",
            top: `${popupPosition.top}px`,
            left: `${popupPosition.left}px`,
          }}
        >
          <div
            style={{
              ...styles.popupArrow,
              ...(popupPosition.showArrowTop
                ? {
                  top: "-8px",
                  left: `${popupPosition.arrowLeft || 8}px`,
                  borderWidth: "0 8px 8px 8px",
                  borderColor: "transparent transparent #e0e0e0 transparent",
                }
                : {
                  bottom: "-8px",
                  left: `${popupPosition.arrowLeft || 8}px`,
                  borderWidth: "8px 8px 0 8px",
                  borderColor: "#e0e0e0 transparent transparent transparent",
                }),
            }}
          />

          <div
            style={{
              ...styles.popupArrow,
              ...(popupPosition.showArrowTop
                ? {
                  top: "-7px",
                  left: `${popupPosition.arrowLeft || 8}px`,
                  borderWidth: "0 8px 8px 8px",
                  borderColor: "transparent transparent #f5f5f5 transparent",
                }
                : {
                  bottom: "-7px",
                  left: `${popupPosition.arrowLeft || 8}px`,
                  borderWidth: "8px 8px 0 8px",
                  borderColor: "white transparent transparent transparent",
                }),
            }}
          />

          <div
            style={{
              ...styles.popup,
              maxHeight: popupPosition.maxHeight
                ? `${popupPosition.maxHeight}px`
                : styles.popup.maxHeight,
            }}
          >
            <div style={styles.popupHeader}>
              <h3 style={styles.popupTitle}>
                <span>🏷️</span>
                Variáveis personalizadas
              </h3>
              <button
                onClick={handleClosePopup}
                style={{
                  ...styles.closeButton,
                  ...(isCloseButtonHovered ? styles.closeButtonHover : {}),
                }}
                onMouseEnter={() => setIsCloseButtonHovered(true)}
                onMouseLeave={() => setIsCloseButtonHovered(false)}
              >
                ✕
              </button>
            </div>

            <div style={styles.searchBox}>
              <div style={styles.searchInputWrapper}>
                <span style={styles.searchIcon}>🔍</span>
                <input
                  type="text"
                  placeholder="Procurar uma variáveis personalizadas..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    ...styles.searchInput,
                    ...(isSearchFocused ? styles.searchInputFocused : {}),
                  }}
                  onFocus={() => setIsSearchFocused(true)}
                  onBlur={() => setIsSearchFocused(false)}
                  autoFocus
                />
              </div>
            </div>

            <div style={styles.placeholderList}>
              {groups.map((group) => {
                const placeholders = groupedPlaceholders[group.id];
                if (placeholders.length === 0) return null;

                return (
                  <div key={group.id}>
                    <div
                      style={{
                        ...styles.groupHeader,
                        ...(hoveredGroup === group.id
                          ? styles.groupHeaderHover
                          : {}),
                      }}
                      onClick={() => handleToggleGroup(group.id)}
                      onMouseEnter={() => setHoveredGroup(group.id)}
                      onMouseLeave={() => setHoveredGroup(null)}
                    >
                      <div style={styles.groupTitle}>
                        <span>{group.icon}</span>
                        <span>{group.name}</span>
                      </div>
                      <span
                        style={{
                          ...styles.expandIcon,
                          transform: expandedGroups[group.id]
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        ▼
                      </span>
                    </div>

                    {expandedGroups[group.id] && (
                      <div>
                        {placeholders.map((placeholder) => (
                          <div
                            key={placeholder.id}
                            style={{
                              ...styles.placeholderItem,
                              ...(hoveredItem === placeholder.id
                                ? styles.placeholderItemHover
                                : {}),
                            }}
                            onClick={() => handleSelectPlaceholder(placeholder)}
                            onMouseEnter={() => setHoveredItem(placeholder.id)}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            <div style={styles.placeholderName}>
                              {placeholder.name}
                            </div>
                            <span style={styles.placeholderCode}>
                              {`{{${placeholder.id}}}`}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}